import template from './estate-table.pug';

export const EstateTableComponent = {
  template,
  bindings: {
    filter: '<',
    records: '<',
    gridOptions: '<?',
    totalRecords: '<',
    totalPages: '<',
    totalCount: '<',
    onFilterChange: '&',
    onPageChange: '&',
    onCheck: '&?',
    isModal: '<?',
    isMobile: '<?',
    onViewChange: '&'
  },
  controller: class EstateTableComponent {
    constructor($log, $stateParams, $localStorage, $state, Estate, RecordStatus, AlertBox, TableEdit, Table) {
      'ngInject';
      this.$log = $log;
      this.$stateParams = $stateParams;
      this.$localStorage = $localStorage;
      this.reload = $state.reload;

      this.Estate = Estate;
      this.TableEdit = TableEdit;
      this.Table = Table;
      this.AlertBox = AlertBox;
      this.RecordStatus = RecordStatus;

      this.checkedIds = [];
      this.totalPages = 0;
      this.totalCount = 0;
      this.totalRecords = 0;
      this.Table.activeFilters.loading = true;
      this.activeTab = 'table';
    }

    $onInit() {
      console.log('filter in estateTable', this.filter);
    }

    changeView({ tab }) {
      this.activeTab = tab;
      this.onViewChange({
        $event: { tab }
      });
    }

    updatePage({ page }) {
      if (parseInt(page) > 0) {
        this.onPageChange({
          $event: { page }
        });
        this.checkedEstates([]);
      }
    }

    applyFilter({ filter, searchId, statusId }) {
      this.onFilterChange({
        $event: { filter: { ...this.filter, ...filter }, searchId, statusId }
      });
    }

    checkedEstates({ checkedIds }) {
      this.checkedIds = checkedIds;
      if (this.onCheck) {
        this.onCheck({
          $event: { checkedIds }
        });
      }
    }

    changeRecordStatus({ status }) {
      this.RecordStatus.setLastStatusId('estate', status.id);
      this.applyFilter({ filter: { ...this.filter, page: 1 }, statusId: status.id, searchId: this.$stateParams.searchId });
    }
  }
};
